import { useEffect, useMemo, useState } from "react";
import { Loader } from "../../components/ui/Loader";
import { AdminProjectsGrid, AdminProject } from "../../components/shared/AdminProjectsGrid";
import { fetchAllProjects } from "../../lib/admin";
import { PROJECT_STATUSES, PROJECT_STATUS_LABELS, ProjectStatus } from "../../models/project";

export const AdminProjects = () => {
  const [projects, setProjects] = useState<AdminProject[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [architect, setArchitect] = useState("");
  const [status, setStatus] = useState<"" | ProjectStatus>("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    fetchAllProjects()
      .then(setProjects)
      .catch((e) => setError(e instanceof Error ? e.message : "Помилка завантаження"))
      .finally(() => setLoading(false));
  }, []);

  const architects = useMemo(
    () =>
      Array.from(
        new Set(projects.map((p) => p.owner_name).filter((n): n is string => !!n))
      ).sort(),
    [projects]
  );

  const filtered = projects.filter((p) => {
    if (architect && p.owner_name !== architect) return false;
    if (status && p.status !== status) return false;
    const day = p.submitted_at.slice(0, 10);
    if (dateFrom && day < dateFrom) return false;
    if (dateTo && day > dateTo) return false;
    return true;
  });

  return (
    <main className="mx-auto w-full max-w-cabinet flex-1 px-5 py-8 md:px-8">
      <h1 className="text-2xl font-bold text-white">Проєкти</h1>

        <section className="sm:card sm:p-5 mt-5 sm:mt-7 grid grid-cols-2 sm:grid-cols-4 items-center gap-x-3 sm:gap-4">
          <label className="block flex-1">
            <span className="mb-2 block text-sm font-semibold text-neutral-300">
              Архітектор
            </span>
            <select
              className="input-dark"
              value={architect}
              onChange={(e) => setArchitect(e.target.value)}
            >
              <option value="" className="text-black">Всі</option>
              {architects.map((a) => (
                <option key={a} value={a} className="text-black">
                  {a}
                </option>
              ))}
            </select>
          </label>
          <label className="block flex-1">
            <span className="mb-2 block text-sm font-semibold text-neutral-300">
              Статус
            </span>
            <select
              className="input-dark"
              value={status}
              onChange={(e) => setStatus(e.target.value as "" | ProjectStatus)}
            >
              <option value="" className="text-black">Всі</option>
              {PROJECT_STATUSES.map((s) => (
                <option key={s} value={s} className="text-black">
                  {PROJECT_STATUS_LABELS[s]}
                </option>
              ))}
            </select>
          </label>
          <label className="block flex-1">
            <span className="mb-2 block text-sm font-semibold text-neutral-300">
              Дата з
            </span>
            <input
              className="input-dark"
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label className="block flex-1">
            <span className="mb-2 block text-sm font-semibold text-neutral-300">
              Дата по
            </span>
            <input
              className="input-dark"
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>
        </section>

        {loading ? (
          <Loader />
        ) : error ? (
          <p className="mt-6 rounded border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400">
            {error}
          </p>
        ) : filtered.length === 0 ? (
          <p className="card mt-7 px-5 py-12 sm:p-12 text-center text-sm text-neutral-400">
            Проєктів не знайдено
          </p>
        ) : (
          <section className="card mt-5 sm:mt-7 p-4 sm:p-6">
            <AdminProjectsGrid projects={filtered} />
          </section>
        )}
    </main>
  );
};
